import { News } from '../../interfaces/News';
import { NewsDto } from '../../interfaces/dto/NewsDto';

export default function transformNewsData(newsDto: NewsDto): News[] {
  const newsData: News[] = [];

  newsDto?.sitecore.route.placeholders.Jss[0].fields.forEach((f) => {
    newsData.push({
      title: f.title,
      summary: f.summary,
      id: f.id,
      newsDate: f.newsDate,
      activationDate: f.activationDate,
      itemPath: f.itemPath,
    });
  });
  return newsData.sort((d2, d1) => new Date(d1.activationDate).getTime() - new Date(d2.activationDate).getTime());
}
